<script>
import BecomePartnerForm from './become-partner-form';
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Devenir Partenaire",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {BecomePartnerForm, Layout}
};
</script>

<style scoped>



</style>

<template>
  <layout>

    <div class="bg-light text-center pt-md-5 pb-md-5 pt-0 pb-0 pr-md-2 pl-md-2 pr-0 pl-0">
      <div>
        <div class="pt-0">
          <h1 class="pt-5 text-dark text-wrap font-weight-bold" style="font-size:2.5rem;">
            {{$t('ourPartner.joinUs')}}
          </h1>
        </div>

        <hr class="separator-line mt-3 mb-3">

        <div class="mt-5 pb-5 pb-md-0">
          <h6 class="header-60-width mx-auto text-dark font-size-16 text-wrap" style="letter-spacing: 0.08em; line-height: 1.8;">
            {{$t('ourPartner.partnersDescription')}} 
          </h6>
        </div>
      </div>
    </div>

    
  <div>
    
  <div class="bg-light pb-5">
    <div class="row header-60-width justify-content-center">
        <div class="col-12  p-lg-2 p-md-2 p-0" >
            <div class="card overflow-hidden login-card-border" style="">
                <BecomePartnerForm/>
            </div>
        </div>
    </div>
  </div>



  </div>
</layout>
</template>


<style scoped>

.separator-line {
  width: 15%;
  height: 4px;
  background-color: #137437;
  border: none;
  margin: auto;
}

.header-60-width,
.sub-title-60-width {
  max-width: 90%;
  margin: auto;
}

@media (min-width: 768px) {
    .header-60-width,
    .sub-title-60-width {
        max-width: 60%;
    }
}

</style>